<template>
  <router-view />
</template>

<style>
@font-face {
  font-family: "Helvetica Neue LT Std";
  src: url("../public/HelveticaNeueLTStd-Roman.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/* Light mode */
:root {
  font-family: "Helvetica Neue LT Std", Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  --background-color: #eeeeee;
  --primary-text-color: #000000;
  --secondary-text-color: #3c3c3c;
  --secondary-background-color: #DBDBDB;
  --tertiary-background-color: #EAEAEA;
  --action-letter-spacing: -5%;
  --navbar-height: 177px;
  letter-spacing: var(--action-letter-spacing);
  line-height: 100%;
}

/* Dark mode */
[data-theme="dark"] {
  --background-color: #000000;
  --primary-text-color: #e8e8e8;
  --secondary-text-color: #a9a9a9;
  --secondary-background-color: #141414;
  --tertiary-background-color: #202020;
}

body {
  background-color: var(--background-color);
  color: var(--primary-text-color);
  position: absolute;
  width: 100dvw;
  height: 100dvh;
  overflow: clip;
}

@keyframes fadeIn {
  from {
    opacity: 0.15;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  opacity: 1;
  animation: fadeIn 0.25s ease-in ;
}
</style>

<script setup>
import { useThemeStore } from "./stores/useThemeStore";

useThemeStore.init();
</script>
